export default __webpack_public_path__ + "static/media/superseedLogo.13781957.svg";